export const CIVILITE_OPTIONS = [
    { id: 102, value: '102', label: 'M.' },
    { id: 103, value: '103', label: 'Mme' },
];

export type CiviliteOption = (typeof CIVILITE_OPTIONS)[number];

export type ContactFormData = {
    civilite: CiviliteOption | null;
    nomContact: string;
    prenomContact: string;
    email: string;
    telephone: string;
};
